<template>
    <div class="attr">
        <span class="attr-label">{{ value.label }}</span>
        <div v-if="Array.isArray(value.value)" class="attr-chips">
            <span
                v-for="item in value.value"
                :key="typeof item === 'object' ? item.value : item"
                class="attr-chip"
            >
                {{ typeof item === 'object' ? (item.text || item.label || item.value) : item }}
            </span>
        </div>
        <div v-else-if="typeof value.value === 'boolean'" class="attr-bool">
            <i :class="value.value ? 'fal fa-check-circle attr-bool-yes' : 'fal fa-times-circle attr-bool-no'"></i>
            <span>{{ $t(`post.page.answers.boolean.${value.value}`) }}</span>
        </div>
        <div v-else class="attr-value">
            {{ value.value }}
        </div>
    </div>
</template>

<script>
/**
 * SPDX-FileCopyrightText: © 2021-2026 SAS Cœur du Web, Paris (France) — https://coeurduweb.com
 * SPDX-License-Identifier: LicenseRef-CoeurDuWeb-Proprietary
 *
 * Tous droits réservés. Logiciel propriétaire, non libre.
 * Les conditions d'utilisation, le périmètre de la licence concédée et les
 * restrictions applicables figurent dans le fichier LICENCE.md à la racine du dépôt.
 */
export default {
    name: 'CheckboxAttribute',
    props: ['value']
}
</script>

<style scoped>
.attr-label {
    display: block;
    font-size: 0.72rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    color: #94a3b8;
    margin-bottom: 6px;
}

.attr-value {
    font-size: 0.9rem;
    color: #1e293b;
    line-height: 1.6;
}

.attr-chips {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
}

.attr-chip {
    display: inline-flex;
    align-items: center;
    padding: 4px 12px;
    background: #f1f5f9;
    color: #475569;
    border-radius: 16px;
    font-size: 0.82rem;
    font-weight: 500;
}

.attr-bool {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 0.9rem;
    color: #1e293b;
}

.attr-bool-yes {
    color: #10b981;
    font-size: 1rem;
}

.attr-bool-no {
    color: #ef4444;
    font-size: 1rem;
}
</style>
